import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessTasasMoraPreacordadas } from '../utils/gestionCampanaAccess'

const RequireTasasMoraPreacordadasAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessTasasMoraPreacordadas(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireTasasMoraPreacordadasAccess
